//variables de entorno
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
//const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
//const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;


type Street = {
  streetId: string;
  streetDescription: string;
  streetTypeId: string;
  streetTypeName: string;
  postalCodeId: string;
};

type Town = {
  townId: string;
  townName: string;
  provinceId: string;
  provinceDesc: string;
};

type NormalizedAddressResponse = {
  horizontalId: string;
  verticalId: string;
};

const fetchData = async <T>(url: string, options?: RequestInit, customHeaders?: Record<string, string>): Promise<T> => {
  const headers = {
    ...options?.headers,
    ...customHeaders,
  };

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (!response.ok) {
    throw new Error(`Error en la solicitud: ${response.status} ${response.statusText}`);
  }

  return response.json();
};


// Servicio para obtener localidades  (GET Towns)
export const fetchTowns = async (postalCodeId?: string): Promise<{}> => {
  try {
    const url = new URL(`${API_BASE_URL}/towns`);
    if (postalCodeId) url.searchParams.append("postalCodeId", postalCodeId);

    const data = await fetchData<{ items: Town[] }>(url.toString(), {});

    if (!data.items || !Array.isArray(data.items)) {
      throw new Error("La respuesta no tiene la estructura esperada");
    }

    const mappedTowns = await Promise.all(
      data.items.map(async (town) => {
        const base = {
          townName: town.townName,
          provinceDesc: town.provinceDesc,
          townId: town.townId,
          municipalityName: town.townName,
        };

        const provinceCode = town.townId.substring(0, 2);
        const municipalityCode = town.townId.substring(2, 5);

        try {

          const municipioUrl = new URL(`${API_BASE_URL}/municipalityName`);
          municipioUrl.searchParams.append("municipalityCode", municipalityCode);
          municipioUrl.searchParams.append("provinceCode", provinceCode);

          const resp = await fetch(municipioUrl.toString());
          console.log(resp);
          if (!resp.ok) throw new Error(`Status ${resp.status}`);
          const extra: {
            municipalityName: string;
          } = await resp.json();
          return {
            ...base,
            municipalityName: extra.municipalityName,
          };
        } catch (err) {
          console.error("Error al obtener municipalityName:", err);
          return base;
        }
      })
    );

    return mappedTowns;
  } catch (error) {
    console.error("Error al obtener municipios:", error);
    return [];
  }

};


// Servicio para obtener calles (GET Streets)
export const fetchStreets = async (postalCodeId?: string, townId?: string): Promise<{}> => {
  try {
    const params = new URLSearchParams();
    if (postalCodeId) params.append("postalCodeId", postalCodeId);
    if (townId) params.append("townId", townId);

    const url = `${API_BASE_URL}/streets?${params.toString()}&wayDesc=`;
    const data = await fetchData<{ items: Street[] }>(url.toString(), {});

    if (!data.items || !Array.isArray(data.items)) {
      throw new Error("La respuesta no tiene la estructura esperada");
    }

    return data.items.map((street) => ({
      streetDescription: street.streetDescription,
      streetTypeName: street.streetTypeName,
      streetId: street.streetId,
    }));
  } catch (error) {
    console.error("Error al obtener calles:", error);
    return [];
  }


};

// Servicio para obtener dirección normalizada  (GET Codigo Maestro)
export const fetchNormalizedAddress = async (addressData: any): Promise<NormalizedAddressResponse> => {
  try {
    const url = `${API_BASE_URL}/compruebaDireccion`;
    const data = await fetchData<NormalizedAddressResponse>(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(addressData),
    });
    return {
      horizontalId: data.horizontalId || "",
      verticalId: data.verticalId || "",
    };
  } catch (error) {
    console.error("Error al obtener dirección normalizada:", error);
    return { horizontalId: "", verticalId: "" };
  }
};
